import { useState } from 'react';
import { useFormikContext } from 'formik';
import type { SendDocumentEmailValues } from './types';

const useEmailRecipientsPicker = () => {
    const [showPicker, setShowPicker] = useState(false);
    const { values, setFieldValue, isSubmitting } = useFormikContext<SendDocumentEmailValues>();
    const selectEmails = (emails: string[]) => {
        const seen = new Set<string>();
        const recipients = [...values.email.split(','), ...emails].map((email) => email.trim()).filter((email) => {
            const key = email.toLowerCase();
            if (!key || seen.has(key)) return false;
            seen.add(key);
            return true;
        });
        void setFieldValue('email', recipients.join(', '));
    };
    return { showPicker, openPicker: () => { if (!isSubmitting) setShowPicker(true); }, closePicker: () => setShowPicker(false), selectEmails };
};

export default useEmailRecipientsPicker;
